<template>
    <div class="sliderWrap">
        <div class="navigation-wrapper">
            <div class="keen-slider zoom-out" ref="slider">
                <div
                        class="keen-slider__slide zoom-out__slide"
                        :style="positionStyle(idx)"
                        v-for="(name, idx) in images"
                        :key="idx"
                >
                    <img :src="require(`../assets/${name}`)">
                </div>
            </div>
            <div @click="slider.prev()"
                 :class="{arrow: true, 'arrow--left': true, 'arrow--disabled': current === 0}">
                <svg xmlns="http://www.w3.org/2000/svg">
                    <path xmlns="http://www.w3.org/2000/svg"
                          d="M7.1971 1L7.1971 41M7.1971 41L13.3943 34.8028M7.1971 41L0.999919 34.8028" stroke="black"
                          stroke-linecap="round" stroke-linejoin="bevel"/>
                </svg>
            </div>
            <div v-if="slider"
                 @click="slider.next()"
                 :class="{arrow: true, 'arrow--right': true, 'arrow--disabled': current === slider.details().size - 1}">
                <svg xmlns="http://www.w3.org/2000/svg">
                    <path xmlns="http://www.w3.org/2000/svg"
                          d="M7.1971 1L7.1971 41M7.1971 41L13.3943 34.8028M7.1971 41L0.999919 34.8028" stroke="black"
                          stroke-linecap="round" stroke-linejoin="bevel"/>
                </svg>
            </div>
        </div>
        <div v-if="slider" class="dots">
            <button
                    v-for="(slide, idx) in dotHelper"
                    @click="slider.moveToSlideRelative(idx)"
                    :class="{dot: true, active: current === idx}"
                    :key="idx"
            ></button>
        </div>
    </div>
</template>

<script>
    import KeenSlider from "keen-slider";
    import "keen-slider/keen-slider.min.css";

    export default {
        name: "Slider",
        props: ['sliderSlides'],
        computed: {
            dotHelper() {
                return this.slider ? [...Array(this.slider.details().size).keys()] : [];
            }
        },
        data() {
            return {
                images: this.sliderSlides,
                details: null,
                current: 0,
                slider: null
            };
        },
        methods: {
            positionStyle(idx) {
                if (!this.details) return {};
                const position = this.details.positions[idx];
                const x = this.details.widthOrHeight * position.distance;
                const scale_size = 0.7;
                const scale = 1 - (scale_size - scale_size * position.portion);
                return {
                    transform: `translate3d(${x}px, 0px, 0px) scale(${scale})`,
                    WebkitTransform: `translate3d(${x}px, 0px, 0px) scale(${scale})`
                };
            }
        },
        mounted() {

            this.slider = new KeenSlider(this.$refs.slider, {
                loop: false,
                slides: this.images.length,
                move: s => {
                    this.details = s.details();
                    this.$forceUpdate();
                },
                initial: this.current,
                slideChanged: s => {
                    this.current = s.details().relativeSlide;
                }
            });
        },
        beforeDestroy() {
            if (this.slider) this.slider.destroy();
        }
    };
</script>

<style>
    .zoom-out {
        perspective: 1000px;
        height: 50vw;
    }

    @media (min-width: 768px) {
        .zoom-out {
            height: 100%;
        }
    }

    .zoom-out__slide {
        position: absolute;
    }

    .zoom-out__slide img {
        background-color: transparent;
        width: 100%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        -webkit-transform: translateY(-50%) translateX(-50%);
    }

    /*navigation*/
    .sliderWrap {
        height: 100%;
    }

    .navigation-wrapper {
        height: 100%;
        position: relative;
    }

    .dots {
        display: flex;
        padding: 10px 0;
        justify-content: center;
        display: none;
    }

    .dot {
        border: none;
        width: 10px;
        height: 10px;
        background: #c5c5c5;
        border-radius: 50%;
        margin: 0 5px;
        padding: 5px;
        cursor: pointer;
    }

    .dot:focus {
        outline: none;
    }

    .dot.active {
        background: #000;
    }

    .arrow {
        width: 72px;
        height: 72px;
        position: absolute;
        top: 44%;
        cursor: pointer;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .arrow svg {
        width: 14px;
        height: 42px;

    }
    .arrow--left {
        left: 0;
        transform: rotate(90deg);
    }

    .arrow--right {
        left: auto;
        right: 0;
        transform: rotate(-90deg);
    }

    .arrow--disabled {
        display: none;
    }
</style>